import React, {useEffect, useState} from 'react';

export const parseISODuration = (duration) => {
  if (!duration) return 0;
  const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?/);
  return match ? Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0) : 0;
};
export const usePreflightTimer = (expectedWaitTime, active) => {
  const [timeLeft, setTimeLeft] = useState(expectedWaitTime);
  useEffect(() => {
    if (!active || expectedWaitTime <= 0) {
      setTimeLeft(expectedWaitTime);
      return undefined;
    }
    const startedAt = Date.now();
    const timer = window.setInterval(() => setTimeLeft(Math.max(expectedWaitTime - (Date.now() - startedAt) / 1000, 0)), 100);
    return () => window.clearInterval(timer);
  }, [expectedWaitTime, active]);
  return timeLeft;
};
const PreflightLoader = ({expectedWaitTime = 0, compact = false, hideText = false}) => {
  const timeLeft = usePreflightTimer(expectedWaitTime, expectedWaitTime > 0);
  const progress = expectedWaitTime > 0 ? Math.min(100, ((expectedWaitTime - timeLeft) / expectedWaitTime) * 100) : 0;
  const label = expectedWaitTime > 0 ? `Preparing your exercise · ${timeLeft.toFixed(1)}s left` : 'Preparing your exercise…';
  if (compact) return <div className="ai-loader ai-loader--compact" aria-live="polite">{!hideText && <span>{label}</span>}{expectedWaitTime > 0 ?
      <div className="progress-track progress-track--thin"><span className="progress-track__fill" style={{width: `${progress}%`}}/></div> : <span className="loader-dot"/>}</div>;
  return <div className="ai-loader" aria-live="polite">
    <div className="ai-loader__icon"><i className="material-icons" aria-hidden="true">auto_awesome</i></div>
    <h2>Preparing your exercise</h2>{!hideText && <p>{label}</p>}{expectedWaitTime > 0 &&
      <div className="progress-track"><span className="progress-track__fill" style={{width: `${progress}%`}}/></div>}</div>;
};
export default PreflightLoader;
